import { NoSsr } from "@mui/material";
import defaultProfilePic from "@public/assets/images/blank-profile-picture.png";
import postClasses from "@styles/post/post.module.css";
import Image from "next/legacy/image";
import { useRouter } from "next/router";
import React from "react";
const ProfilePreview = ({
  postCommunity
}) => {
  const router = useRouter();
  return <div className={postCommunity ? postClasses.post__avatar__container : postClasses.blog__avatar__container} onClick={() => {
    if (postCommunity) router.push(`/community/${postCommunity.urlExtension}`);
  }} data-sentry-component="ProfilePreview" data-sentry-source-file="ProfilePreview.jsx">
      <NoSsr data-sentry-element="NoSsr" data-sentry-source-file="ProfilePreview.jsx">
        <div className={postClasses.post__avatar__community}>
          <Image src={postCommunity?.dp || defaultProfilePic} alt={`${postCommunity?.name} dp`} width="60" height="60" objectFit="cover" style={{
          borderRadius: "50%"
        }} data-sentry-element="Image" data-sentry-source-file="ProfilePreview.jsx" />
        </div>
      </NoSsr>
    </div>;
};
const areEqual = (prevProps, nextProps) => {
  if (prevProps.postUser?.uid === nextProps.postUser?.uid && prevProps.postCommunity?.communityID === nextProps.postCommunity?.communityID) {
    return true;
  }
  return false;
};
export default React.memo(ProfilePreview, areEqual);